import TicketPicker from 'customer-flows/components/booking/ticket-picker.gts'
import type { TOC } from '@ember/component/template-only';

interface ExtensionKitTicketPickerArgs {
  Args: {
    loading: boolean
    disabled?: boolean
    available: boolean
    name: string
    description?: string
    images: string[]
    hasError: boolean
    priceTagText: string | null
    count: number
    max: number
    min: number
    plusTooltip: string
    minusTooltip: string
    countIncremented: () => void
    countDecremented: () => void
    isMultiTicket?: boolean
    onMultiTicketClick?: () => void
  }
  Blocks: {
    after: []
  }
}

<template>
  <TicketPicker
    @loading={{@loading}}
    @disabled={{@disabled}}
    @available={{@available}}
    @name={{@name}}
    @description={{@description}}
    @images={{@images}}
    @hasError={{@hasError}}
    @priceTagText={{@priceTagText}}
    @count={{@count}}
    @max={{@max}}
    @min={{@min}}
    @plusTooltip={{@plusTooltip}}
    @minusTooltip={{@minusTooltip}}
    @countIncremented={{@countIncremented}}
    @countDecremented={{@countDecremented}}
    @isMultiTicket={{@isMultiTicket}}
    @onMultiTicketClick={{@onMultiTicketClick}}
  >
    <:after>
      {{yield to='after'}}
    </:after>
  </TicketPicker>
</template> satisfies TOC<ExtensionKitTicketPickerArgs>
